export const sortLinkedDropdown = (array = [], subKey = "") => {
  if (!Array.isArray(array)) {
    throw new Error("El primer argumento debe ser un array");
  }

  const sortedArray = array
    .map((item) => {
      if (typeof item !== "object" || !item.name || !item.id) {
        throw new Error(
          "Cada elemento del array debe ser un objeto con 'name' e 'id'"
        );
      }

      if (subKey && item[subKey]) {
        if (!Array.isArray(item[subKey])) {
          throw new Error(`La propiedad ${subKey} debe ser un array`);
        }

        item[subKey] = item[subKey].sort((subItemA, nextSubItem) =>
          subItemA.name.localeCompare(nextSubItem.name)
        );
      }

      return {
        ...item,
        label: item.name,
        value: item.id,
      };
    })
    .sort((item, nexItem) => item.name.localeCompare(nexItem.name));

  return sortedArray;
};
